/**
 * Ten cac socket events -- dong bo voi backend/src/socket/events.ts
 */

// ---- CLIENT -> SERVER ----
export const CLIENT_EVENTS = {
  JOIN_ROOM: 'client:join_room',
  LEAVE_ROOM: 'client:leave_room',
  SUBMIT_ANSWER: 'client:submit_answer',
  HOST_JOIN: 'client:host_join',
  HOST_LEAVE: 'client:host_leave',
  HOST_START_ROUND: 'client:host_start_round',
  HOST_REVEAL_ANSWER: 'client:host_reveal_answer',
  HOST_NEXT_QUESTION: 'client:host_next_question',
  HOST_END_ROUND: 'client:host_end_round',
  HOST_OPEN_ROOM: 'client:host_open_room',
  HOST_CLOSE_ROOM: 'client:host_close_room',
  REJOIN_ROOM: 'client:rejoin_room',
  CHAT_MESSAGE: 'client:chat_message',
  // RPS
  RPS_CHOOSE: 'client:rps_choose',
  SPOTLIGHT_MATCH: 'client:spotlight_match',
  HOST_FORCE_COMPLETE_ROUND: 'client:host_force_complete_round',
  HOST_START_GAMES: 'client:host_start_games',
  HOST_START_NEXT_ROUND: 'client:host_start_next_round',
  // Word Chain
  WORD_CHAIN_SUBMIT: 'client:word_chain_submit',
  WORD_CHAIN_SUBMIT_WORD: 'client:word_chain_submit_word',
  // RPS Room (p2p)
  RPS_ROOM_JOIN: 'client:rps_room_join',
  RPS_ROOM_LEAVE: 'client:rps_room_leave',
  RPS_ROOM_READY: 'client:rps_room_ready',
  RPS_ROOM_CHOOSE: 'client:rps_room_choose',
  RPS_ROOM_CHAT: 'client:rps_room_chat',
} as const;

// ---- SERVER -> CLIENT ----
export const SERVER_EVENTS = {
  ROOM_JOINED: 'server:room_joined',
  PARTICIPANT_JOINED: 'server:participant_joined',
  PARTICIPANT_LEFT: 'server:participant_left',
  ROUND_STARTING: 'server:round_starting',
  ROUND_STARTED: 'server:round_started',
  QUESTION_STARTED: 'server:question_started',
  ANSWER_RECEIVED: 'server:answer_received',
  ANSWER_COUNT_UPDATED: 'server:answer_count_updated',
  QUESTION_REVEALED: 'server:question_revealed',
  QUESTION_STARTING: 'server:question_starting',
  ROUND_ENDED: 'server:round_ended',
  ROOM_CLOSED: 'server:room_closed',
  ERROR: 'server:error',
  AUTH_REVOKED: 'server:auth_revoked',
  CHAT_MESSAGE: 'server:chat_message',
  // RPS
  BRACKET_DRAW_STARTED: 'server:bracket_draw_started',
  TOURNAMENT_ROUND_STARTED: 'server:tournament_round_started',
  SUB_ROUND_STARTED: 'server:sub_round_started',
  PLAYER_READY: 'server:player_ready',
  SUB_ROUND_REVEALED: 'server:sub_round_revealed',
  MATCH_COMPLETED: 'server:match_completed',
  TOURNAMENT_ROUND_COMPLETED: 'server:tournament_round_completed',
  TOURNAMENT_ENDED: 'server:tournament_ended',
  // Word Chain
  WORD_CHAIN_STARTED: 'server:word_chain_started',
  WORD_CHAIN_SUBMIT_COUNT_UPDATED: 'server:word_chain_submit_count_updated',
  WORD_CHAIN_REVEALED: 'server:word_chain_revealed',
  WORD_CHAIN_WORD_RESULT: 'server:word_chain_word_result',
  WORD_CHAIN_WORD_CORRECT: 'server:word_chain_word_correct',
  WORD_CHAIN_WORD_PHASE_STARTED: 'server:word_chain_word_phase_started',
  WORD_CHAIN_WORD_PHASE_ENDED: 'server:word_chain_word_phase_ended',
  // RPS Room (p2p)
  RPS_ROOM_JOINED: 'server:rps_room_joined',
  RPS_ROOM_STATE_UPDATED: 'server:rps_room_state_updated',
  RPS_ROOM_PLAYER2_LEFT: 'server:rps_room_player2_left',
  RPS_ROOM_READY_UPDATED: 'server:rps_room_ready_updated',
  RPS_ROOM_MATCH_STARTED: 'server:rps_room_match_started',
  RPS_ROOM_GAME_STARTED: 'server:rps_room_game_started',
  RPS_ROOM_PLAYER_CHOSEN: 'server:rps_room_player_chosen',
  RPS_ROOM_GAME_REVEALED: 'server:rps_room_game_revealed',
  RPS_ROOM_MATCH_ENDED: 'server:rps_room_match_ended',
  RPS_ROOM_CLOSED: 'server:rps_room_closed',
  RPS_ROOM_CHAT_MESSAGE: 'server:rps_room_chat_message',
} as const;
